import dayjs from 'dayjs';

/** APT336: an API date ('2026-03-31') as the app shows dates in period labels: 31-Mar-2026. */
export function reversalDate(value: string | null | undefined): string {
  if (!value) return '';
  const date = dayjs(value);
  return date.isValid() ? date.format('DD-MMM-YYYY') : '';
}

/** APT336: '01-Apr-2026 - 31-Mar-2027', or '' when either date is missing. */
export function reversalPeriodRange(start: string | null | undefined, end: string | null | undefined): string {
  const from = reversalDate(start);
  const to = reversalDate(end);
  return from && to ? `${from} - ${to}` : '';
}

interface ReversalLinkFields {
  reversalOfJournalNo?: number | null;
  reversedByJournalNo?: number | null;
  reversalOfPeriodStart?: string | null;
  reversalOfPeriodEnd?: string | null;
  reversedByPeriodStart?: string | null;
  reversedByPeriodEnd?: string | null;
}

/**
 * 'Reversal of #n' / 'Reversed by #m'. A reversal can sit in the NEXT accounting period (year-end adjustments), so when the linked
 * journal is in another period the period's dates follow: 'Reversal of #3 (01-Apr-2025 - 31-Mar-2026)', 'Reversed by #1 in
 * 01-Apr-2026 - 31-Mar-2027'. The API may not send the numbers (older builds), so each part is optional.
 */
export function reversalLinkParts(row: ReversalLinkFields, capitalise = true): string[] {
  const parts: string[] = [];
  const word = (text: string) => (capitalise ? text : text.charAt(0).toLowerCase() + text.slice(1));

  if (row.reversalOfJournalNo != null) {
    const range = reversalPeriodRange(row.reversalOfPeriodStart, row.reversalOfPeriodEnd);
    parts.push(`${word('Reversal of')} #${row.reversalOfJournalNo}${range ? ` (${range})` : ''}`);
  }
  if (row.reversedByJournalNo != null) {
    const range = reversalPeriodRange(row.reversedByPeriodStart, row.reversedByPeriodEnd);
    parts.push(`${word('Reversed by')} #${row.reversedByJournalNo}${range ? ` in ${range}` : ''}`);
  }
  return parts;
}
